import { HeaderEditButton, SignedCounter } from 'components';
import { COMMUNITY_ROUTES } from 'configs';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { CommunityPlaceholder } from 'static';

import {
  Container,
  Cover,
  CoverBG,
  Footer,
  Head,
  Logo,
  LogoPlaceholder,
  LogoWrapper,
  MembersInfo,
  StyledLink,
  Title,
} from './styled';

interface HeaderProps {
  title: string;
  cover: string | null;
  logo: string | null;
  isUserInCommunity: boolean;
  isMenuOpen: boolean;
  hasAdminPermissions: boolean;
  usersCount: number;
}

const Header: FC<HeaderProps> = ({
  cover,
  logo,
  title,
  isUserInCommunity,
  isMenuOpen,
  hasAdminPermissions,
  usersCount,
}) => {
  const { t } = useTranslation();
  const styleBtn = {
    marginRight: '0px',
  };
  return (
    <Container>
      <Head isMenuOpen={isMenuOpen}>
        <Title>{title}</Title>
        {hasAdminPermissions && (
          <StyledLink to={COMMUNITY_ROUTES.SETTINGS}>
            <HeaderEditButton
              title={t('communitySettings.title')}
              style={styleBtn}
            />
          </StyledLink>
        )}
      </Head>
      <Cover src={cover || CommunityPlaceholder} />
      <CoverBG src={cover || CommunityPlaceholder} />
      <Footer>
        <LogoWrapper>
          {logo ? (
            <Logo src={logo} />
          ) : (
            <LogoPlaceholder>{title.charAt(0).toUpperCase()}</LogoPlaceholder>
          )}
        </LogoWrapper>
        <MembersInfo>
          <SignedCounter
            value={usersCount || 0}
            description={t('community.members')}
          />
          {/* {isUserInCommunity && (
            <SignedCounter
              value={0}
              description={t('community.online')}
              variant="primary"
            />
          )} */}
        </MembersInfo>
      </Footer>
    </Container>
  );
};

export default Header;
